import React from 'react';
import ReactApexChart from 'react-apexcharts';

const LineChart = ({ categories, data, title }) => {
  const chartOptions = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight', // Ensures a wave-like smoothness
      width: 3,
      colors: ['#FF814E'],
    },
    markers: {
      size: 6,
      colors: ['#FF7A3C'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: {
        size: 8,
      },
    },
    annotations: {
      points: [
        {
          x: categories[categories.length - 1] || 'Week 4',
          y: data[data.length - 1] || 20,
          marker: {
            size: 0,
            fillColor: '#FF7A3C',
            customSVG: `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#FF7A3C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>`
          },
        },
      ],
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: categories || ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
      labels: {
        style: {
          fontSize: '12px',
          colors: '#999',
        },
      },
      axisBorder: {
        show: true,
        color: '#e7e7e7',
      },
      axisTicks: {
        show: true,
        color: '#e7e7e7',
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
          colors: '#999',
        },
      },
      axisBorder: {
        show: true,
        color: '#e7e7e7',
      },
      axisTicks: {
        show: true,
        color: '#e7e7e7',
      },
    },
  };

  const chartSeries = [
    {
      name: 'Data Series',
      data: data || [5, 15, 10, 20], // Modified data for a wave-like effect
    },
  ];

  return (
    <div>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
};

export default LineChart;
